import React from 'react'
import { useNavigate } from 'react-router-dom'

const Reconciliation = () => {
  const navigate = useNavigate()
  return (
    <div style={{ padding: '32px', width: '100%' }}>
      <div
        style={{
          fontSize: '28px',
          fontWeight: '700',
          lineHeight: '32px',
          color: '#575757',
        }}
      >
        Reconciliation
      </div>
      <div
        style={{
          marginTop: '40px',
          display: 'flex',
          flexDirection: 'row',
          columnGap: '16px',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          flexWrap: 'wrap',
          rowGap: '16px',
        }}
      >
        {/* Upload Bank Statement */}
        <div
          style={{ cursor: 'pointer' }}
          onClick={() => navigate('/createBranchPayment')}
        >
          <div
            style={{
              justifyContent: 'center',
              alignItems: 'center',
              display: 'flex',
              flexDirection: 'column',
              height: '128px',
              padding: '24px 16px',
              borderRadius: '8px',
              border: '1px solid rgba(156,39,176,0.3)',
              background: 'rgba(156,39,76,0.08)',
              width: '360px',
            }}
          >
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 24 24"
              >
                <path
                  fill="#9c27b0"
                  d="M18 12c-.55 0-1 .45-1 1v5.22c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1h5c.55 0 1-.45 1-1s-.45-1-1-1H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-6c0-.55-.45-1-1-1m3.02-7H19V2.98c0-.54-.44-.98-.98-.98h-.03c-.55 0-.99.44-.99.98V5h-2.01c-.54 0-.98.44-.99.98v.03c0 .55.44.99.99.99H17v2.01c0 .54.44.99.99.98h.03c.54 0 .98-.44.98-.98V7h2.02c.54 0 .98-.44.98-.98v-.04c0-.54-.44-.98-.98-.98"
                />
                <path
                  fill="#9c27b0"
                  d="M14 9H8c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1m0 3H8c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1m0 3H8c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1"
                />
              </svg>
            </div>
            <div
              style={{
                fontSize: '16px',
                fontWeight: '600',
                lineHeight: '20px',
                color: '#9c27b0',
                marginTop: '8px',
              }}
            >
              Upload Bank Statement
            </div>
          </div>
        </div>

        {/* Track Reconciliation */}
        <div
          style={{ cursor: 'pointer' }}
          onClick={() => navigate('/trackreconciliation')}
        >
          <div
            style={{
              justifyContent: 'center',
              alignItems: 'center',
              display: 'flex',
              flexDirection: 'column',
              height: '128px',
              padding: '24px 16px',
              borderRadius: '8px',
              border: '1px solid rgba(39,176,108,0.3)',
              background: 'rgba(39, 176, 108, 0.08)',
              width: '360px',
            }}
          >
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 16 16"
              >
                <path
                  fill="none"
                  stroke="#27b06b"
                  strokeLinejoin="round"
                  d="M7.563 1.545H2.5v10.91h9V5.364M7.563 1.545L11.5 5.364M7.563 1.545v3.819H11.5m-7 9.136h9v-7M4 7.5h6M4 5h2m-2 5h6"
                />
              </svg>
            </div>
            <div
              style={{
                fontSize: '16px',
                fontWeight: '600',
                lineHeight: '20px',
                color: '#27b06b',
                marginTop: '8px',
              }}
            >
              Track Reconciliation
            </div>
          </div>
        </div>

        {/* UPI Transactions */}
        <div
          style={{ cursor: 'pointer' }}
          onClick={() => navigate('/upitransactions')}
        >
          <div
            style={{
              justifyContent: 'center',
              alignItems: 'center',
              display: 'flex',
              flexDirection: 'column',
              height: '128px',
              padding: '24px 16px',
              borderRadius: '8px',
              border: '1px solid rgba(3,86,66,0.3)',
              background: 'rgba(3, 86, 66, 0.08)',
              width: '360px',
            }}
          >
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 24 24"
              >
                <path
                  fill="#035642"
                  d="M20 4H4c-1.11 0-2 .89-2 2v12c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2m0 14H4v-6h16zm0-10H4V6h16z"
                />
                <path fill="#035642" d="M6.5 15.5h3v-2h-3zm4.5 0h3v-2h-3z" />
              </svg>
            </div>
            <div
              style={{
                fontSize: '16px',
                fontWeight: '600',
                lineHeight: '20px',
                color: '#035642',
                marginTop: '8px',
              }}
            >
              UPI Transactions
            </div>
          </div>
        </div>

        {/* PAYMENTS LOCKS */}
        <div
          style={{ cursor: 'pointer' }}
          onClick={() => navigate('/paymentsLocks')}
        >
          <div
            style={{
              justifyContent: 'center',
              alignItems: 'center',
              display: 'flex',
              flexDirection: 'column',
              height: '128px',
              padding: '24px 16px',
              borderRadius: '8px',
              border: '1px solid rgba(25,118,210,0.3)',
              background: 'rgba(25, 118, 210, 0.08)',
              width: '360px',
            }}
          >
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 24 24"
              >
                <path
                  fill="#1976d2"
                  d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2M9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9zm9 14H6V10h12zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2s-2 .9-2 2s.9 2 2 2"
                />
              </svg>
            </div>
            <div
              style={{
                fontSize: '16px',
                fontWeight: '600',
                lineHeight: '20px',
                color: '#1976d2',
                marginTop: '8px',
              }}
            >
              Payments Lock
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Reconciliation
